export class NanoEvent {
  events = {}

  $mute = false

  $emit (event, ...args) {
    if (this.$mute) return
    for (let i of this.events[event] || []) {
      i(...args)
    }
  }

  $on (event, cb) {
    (this.events[event] = this.events[event] || []).push(cb)
    return () => (
      this.events[event] = this.events[event].filter(i => i !== cb)
    )
  }
}
